






import { Component, Vue, Provide } from 'vue-property-decorator'

@Component({})
export default class App extends Vue {
  // isRouterAlive: boolean = true
  // @Provide('isRouter')
  // private value = () => {
  //   return this.reload
  // }
  // reload() {
  //   this.isRouterAlive = false
  //   this.$nextTick(() => {
  //     this.isRouterAlive = true
  //   })
  // }
}
